import { render, staticRenderFns } from "./DiscreteScaleEditor.vue?vue&type=template&id=c2b7d718&scoped=true"
import script from "./DiscreteScaleEditor.vue?vue&type=script&lang=ts"
export * from "./DiscreteScaleEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b7d718",
  null
  
)

export default component.exports